export default __webpack_public_path__ + "static/media/feature1.38728d46.png";